import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RequestTranslationsExportResult {
  translationId: string,
  status: "created"
};

export interface GetTranslationsExportHistoryResult {
  items: TranslationsExportHistoryItem[],
  totalCount: number,
  pageNumber: number,
  maxItems: number
}

export interface TranslationsExportHistoryItem {
  translationId: string,
  userId: string,
  surveyId: string,
  format: FileFormat,
  status: "created" | "completed" | "error",
  createdDate: string,
  updatedDate: string | null,
  downloadUrl: string | null,
  errorDescription: string | null
}

export type FileFormat = "Excel" | "CSV";

@Injectable({ providedIn: 'root' })
export class ApiTranslationsExportService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/translations/export';

  constructor(
    private http: HttpClient) {}

  requestTranslationsExport(organizationId: string, surveyId: string, format: FileFormat = "CSV"): Observable<RequestTranslationsExportResult> {
    const request = {
      organizationId: organizationId,
      surveyId: surveyId,
      format: format
    }

    return this.http.post<RequestTranslationsExportResult>(`${this.apiBaseUrl}${this.apiPath}`, request);
  }
}